"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"
import { ambilKonfigPush } from "@/modules/push/actions/push-actions"
import { bacaTokenLokal, dengarkanLatarDepan, dukunganPush } from "@/modules/push/client/fcm-klien"
import { useToast } from "@/shared/hooks/use-toast"

export function PenerimaPush() {
  const router = useRouter()
  const { toast } = useToast()

  useEffect(() => {
    if (!dukunganPush() || Notification.permission !== "granted" || bacaTokenLokal() === null) return

    let berhenti: (() => void) | null = null
    let batal = false
    ambilKonfigPush()
      .then((konfig) => (konfig ? dengarkanLatarDepan(konfig, (judul, isi) => {
        toast({ title: judul, description: isi })
        router.refresh()
      }) : null))
      .then((lepas) => {
        if (batal) lepas?.()
        else berhenti = lepas
      })
      .catch(() => undefined)

    return () => {
      batal = true
      berhenti?.()
    }
  }, [router, toast])

  return null
}
